"use client";

import { createContext, useContext, type ReactNode } from "react";
import {
  useSellerListingAttention,
  type SellerAttentionPayload,
} from "@/lib/hooks/useSellerListingAttention";
import { EMPTY_SELLER_MY_ITEMS_TAB_COUNTS } from "@/lib/seller/sellerMyItemsTabAttention";

type SellerListingAttentionContextType = SellerAttentionPayload & {
  refresh: () => Promise<SellerAttentionPayload | undefined>;
};

const defaultValue: SellerListingAttentionContextType = {
  needsAttention: false,
  tabCounts: { ...EMPTY_SELLER_MY_ITEMS_TAB_COUNTS },
  itemsNeedingAttentionCount: 0,
  unreadListingNotificationsCount: 0,
  availabilityCheckPendingCount: 0,
  pendingAvailabilityItemIds: [],
  reviewIntentPendingCount: 0,
  pendingReviewIntentItemIds: [],
  refresh: async () => undefined,
};

const SellerListingAttentionContext =
  createContext<SellerListingAttentionContextType>(defaultValue);

export function SellerListingAttentionProvider({
  children,
}: {
  children: ReactNode;
}) {
  const attention = useSellerListingAttention();

  return (
    <SellerListingAttentionContext.Provider value={attention}>
      {children}
    </SellerListingAttentionContext.Provider>
  );
}

export function useSellerListingAttentionContext() {
  return useContext(SellerListingAttentionContext);
}
